import { render } from "./SheetValid.vue?vue&type=template&id=12f761b4"
import script from "./SheetValid.vue?vue&type=script&lang=js"
export * from "./SheetValid.vue?vue&type=script&lang=js"
script.render = render

export default script